import React, { useState } from "react";
import "./CategoriaContainer.css"

const CategoriaContainer = ({ titulo, children }) => {
  const [visivel, setVisivel] = useState(false);

  return (
    <div className="categoria-container">
      <button className="botao-categoria" onClick={() => setVisivel(!visivel)}>
        {titulo}
      </button>
      {visivel && <div className="lista-subcategorias">{children}</div>}
    </div>
  );
};

export default CategoriaContainer;
